// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.bs.js";
import * as Curry from "../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "./Config.bs.js";
import * as ReactDom from "react-dom";
import * as AssetsManager$Catalyst from "../node_modules/@porterin/catalyst/src/assets/AssetsManager.bs.js";
import * as Lib$PorterinFusionkitSentry from "../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

AssetsManager$Catalyst.importFavicon(undefined);

Curry._1(Lib$PorterinFusionkitSentry.React.initSentry, Lib$PorterinFusionkitSentry.React.init_options(Config.Env.getSentryDsn(undefined), undefined, undefined, "gcp-production", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0.1, undefined, undefined, 0.01, 0.01, undefined));

var root = document.querySelector("#root");

if (!(root == null)) {
  ReactDom.render(React.createElement(App.App.make, {}), root);
}

export {
  
}
/*  Not a pure module */
